import { DefaultLayout } from '@fondationcss/ui';

export const getCustomRoutes = () => [
  // ── Root ──────────────────────────────────────────────────
  {
    path: '/',
    component: DefaultLayout,
    meta: { title: 'Alcuin', hideFooter: true },
    children: [
      {
        path: '',
        redirect: '/dashboard',
      },
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('@/views/dashboard.vue'),
        meta: { title: 'Tableau de bord', hideFooter: true },
      },

      // ── Élèves ────────────────────────────────────────────
      {
        name: 'eleves',
        path: 'eleves',
        component: () => import('@/views/students/index.vue'),
        meta: { title: 'Élèves', hideFooter: true },
      },
      {
        name: 'eleve-fiche',
        path: 'eleves/:id',
        component: () => import('@/views/students/detail.vue'),
        meta: { title: 'Fiche élève', hideFooter: true },
      },

      // ── Adresses ──────────────────────────────────────────
      {
        name: 'adresses',
        path: 'adresses',
        component: () => import('@/views/addresses/index.vue'),
        meta: { title: 'Adresses', hideFooter: true },
      },

      // ── FP — Déclarations d'effectif ──────────────────────
      {
        name: 'fp-declarations',
        path: 'fp/declarations',
        component: () => import('@/views/fp/declarations.vue'),
        meta: { title: 'Déclarations d\'effectif — FP', hideFooter: true },
      },
      {
        name: 'fp-declaration-nouveau',
        path: 'fp/declarations/nouveau',
        component: () => import('@/views/fp/declaration-new.vue'),
        meta: { title: 'Nouvelle déclaration — FP', hideFooter: true },
      },
      {
        name: 'fp-declaration-modifier',
        path: 'fp/declarations/:id/modifier',
        component: () => import('@/views/fp/declaration-edit.vue'),
        meta: { title: 'Modifier déclaration — FP', hideFooter: true },
      },

      // ── FP — Déclarations de service ──────────────────────
      {
        name: 'fp-services',
        path: 'fp/services',
        component: () => import('@/views/fp/services.vue'),
        meta: { title: 'Déclarations de service — FP', hideFooter: true },
      },
      {
        name: 'fp-service-nouveau',
        path: 'fp/services/nouveau',
        component: () => import('@/views/fp/service-new.vue'),
        meta: { title: 'Nouvelle décl. service — FP', hideFooter: true },
      },
      {
        name: 'fp-service-modifier',
        path: 'fp/services/:id/modifier',
        component: () => import('@/views/fp/service-edit.vue'),
        meta: { title: 'Modifier décl. service — FP', hideFooter: true },
      },

      // ── FP — Résultats ────────────────────────────────────
      {
        name: 'fp-resultats',
        path: 'fp/resultats',
        component: () => import('@/views/fp/results.vue'),
        meta: { title: 'Résultats — FP', hideFooter: true },
      },
      {
        name: 'fp-resultat-nouveau',
        path: 'fp/resultats/nouveau',
        component: () => import('@/views/fp/result-new.vue'),
        meta: { title: 'Nouveau résultat — FP', hideFooter: true },
      },

      // ── FGA — Déclarations d'effectif ─────────────────────
      {
        name: 'fga-declarations',
        path: 'fga/declarations',
        component: () => import('@/views/fga/declarations.vue'),
        meta: { title: 'Déclarations d\'effectif — FGA', hideFooter: true },
      },
      {
        name: 'fga-declaration-nouveau',
        path: 'fga/declarations/nouveau',
        component: () => import('@/views/fga/declaration-new.vue'),
        meta: { title: 'Nouvelle déclaration — FGA', hideFooter: true },
      },
      {
        name: 'fga-declaration-modifier',
        path: 'fga/declarations/:id/modifier',
        component: () => import('@/views/fga/declaration-edit.vue'),
        meta: { title: 'Modifier déclaration — FGA', hideFooter: true },
      },

      // ── FGJ — Déclarations d'effectif ─────────────────────
      {
        name: 'fgj-declarations',
        path: 'fgj/declarations',
        component: () => import('@/views/fgj/declarations.vue'),
        meta: { title: 'Déclarations d\'effectif — FGJ', hideFooter: true },
      },
      {
        name: 'fgj-declaration-nouveau',
        path: 'fgj/declarations/nouveau',
        component: () => import('@/views/fgj/declaration-new.vue'),
        meta: { title: 'Nouvelle déclaration (FIN/FRE) — FGJ', hideFooter: true },
      },
      {
        name: 'fgj-declaration-sanction',
        path: 'fgj/declarations/sanction',
        component: () => import('@/views/fgj/declaration-sanction.vue'),
        meta: { title: 'Nouvelle sanction (SAN) — FGJ', hideFooter: true },
      },
      {
        name: 'fgj-declaration-modifier',
        path: 'fgj/declarations/:id/modifier',
        component: () => import('@/views/fgj/declaration-edit.vue'),
        meta: { title: 'Modifier déclaration — FGJ', hideFooter: true },
      },

      // ── FGJ — Résultats locaux ────────────────────────────
      {
        name: 'fgj-resultats',
        path: 'fgj/resultats',
        component: () => import('@/views/fgj/results.vue'),
        meta: { title: 'Résultats locaux — FGJ', hideFooter: true },
      },
      {
        name: 'fgj-resultat-nouveau',
        path: 'fgj/resultats/nouveau',
        component: () => import('@/views/fgj/result-new.vue'),
        meta: { title: 'Nouveau résultat — FGJ', hideFooter: true },
      },

      // ── FGJ — Inscriptions épreuves ───────────────────────
      {
        name: 'fgj-inscriptions',
        path: 'fgj/inscriptions',
        component: () => import('@/views/fgj/registrations.vue'),
        meta: { title: 'Inscriptions épreuves — FGJ', hideFooter: true },
      },
      {
        name: 'fgj-inscription-nouveau',
        path: 'fgj/inscriptions/nouveau',
        component: () => import('@/views/fgj/registration-new.vue'),
        meta: { title: 'Nouvelle inscription — FGJ', hideFooter: true },
      },

      // ── Transmission ──────────────────────────────────────
      {
        name: 'transmissions-preparer',
        path: 'transmissions/preparer',
        component: () => import('@/views/transmissions/prepare.vue'),
        meta: { title: 'Préparer et transmettre', hideFooter: true },
      },
      {
        name: 'transmissions',
        path: 'transmissions',
        component: () => import('@/views/transmissions/index.vue'),
        meta: { title: 'Suivi des transmissions', hideFooter: true },
      },
      {
        name: 'transmission-detail',
        path: 'transmissions/:id',
        component: () => import('@/views/transmissions/detail.vue'),
        meta: { title: 'Détail transmission', hideFooter: true },
      },

      // ── Fichiers et rétro-information ─────────────────────
      {
        name: 'fichiers',
        path: 'fichiers',
        component: () => import('@/views/files/index.vue'),
        meta: { title: 'Demander un fichier', hideFooter: true },
      },
      {
        name: 'fichiers-import-initial',
        path: 'fichiers/import-initial',
        component: () => import('@/views/files/initial-import.vue'),
        meta: { title: 'Import initial', hideFooter: true },
      },

      // ── Rapports ──────────────────────────────────────────
      {
        name: 'rapports-sommaire',
        path: 'rapports/sommaire',
        component: () => import('@/views/reports/summary.vue'),
        meta: { title: 'Sommaire des déclarations', hideFooter: true },
      },
      {
        name: 'rapports-heures',
        path: 'rapports/heures',
        component: () => import('@/views/reports/hours.vue'),
        meta: { title: 'Heures déclarées vs sanctionnées', hideFooter: true },
      },
      {
        name: 'rapports-rejets',
        path: 'rapports/rejets',
        component: () => import('@/views/reports/rejections.vue'),
        meta: { title: 'Taux de rejet', hideFooter: true },
      },
      {
        name: 'rapports-couverture',
        path: 'rapports/couverture',
        component: () => import('@/views/reports/coverage.vue'),
        meta: { title: 'Couverture des résultats', hideFooter: true },
      },
      {
        name: 'rapports-audit',
        path: 'rapports/audit',
        component: () => import('@/views/reports/audit.vue'),
        meta: { title: 'Audit trail', hideFooter: true },
      },

      // ── Configuration ─────────────────────────────────────
      {
        name: 'configuration-organisme',
        path: 'configuration/organisme',
        component: () => import('@/views/configuration/organization.vue'),
        meta: { title: 'Organisme', hideFooter: true },
      },
      {
        name: 'configuration-sftp',
        path: 'configuration/sftp',
        component: () => import('@/views/configuration/sftp.vue'),
        meta: { title: 'Connexion SFTP', hideFooter: true },
      },
      {
        name: 'configuration-pgp',
        path: 'configuration/pgp',
        component: () => import('@/views/configuration/pgp.vue'),
        meta: { title: 'Chiffrement PGP', hideFooter: true },
      },
      {
        name: 'configuration-utilisateurs',
        path: 'configuration/utilisateurs',
        component: () => import('@/views/configuration/users.vue'),
        meta: { title: 'Utilisateurs et rôles', hideFooter: true },
      },
      {
        name: 'configuration-notifications',
        path: 'configuration/notifications',
        component: () => import('@/views/configuration/notifications.vue'),
        meta: { title: 'Notifications', hideFooter: true },
      },

      // ── Aide ──────────────────────────────────────────────
      {
        name: 'aide',
        path: 'aide',
        component: () => import('@/views/help/index.vue'),
        meta: { title: 'Aide', hideFooter: true },
      },
    ],
  },
];